import UserProfileHeader from "./userprofileheader";
import UserProfileSidebar from "../../userprofile/userprofilesidebar";

export default function UserProfileLayout({ children }) {
  return (
    <div className="flex flex-col h-screen">
      <UserProfileHeader />
      <div>
        <UserProfileSidebar />
        <div className="ml-[290px] mt-[95px] flex-1 overflow-y-auto">
          {children}
        </div>
      </div>
    </div>
  );
}
